import type { SetStateAction } from 'react';

/**
 * Decides whether a state update should apply immediately or be held behind a
 * discard-confirmation dialog, based on whether there's a conflicting unsaved edit in
 * progress elsewhere. Motivating case: switching the selected timeline item while an
 * edit to the currently-selected one is unsaved silently threw the edit away — nothing
 * reset the unsaved state on a plain selection change the way closing the dialog already
 * did. Pulled out as a plain function so the actual "apply now vs hold" decision is
 * testable without rendering; the caller still owns the pending-update state itself and
 * what "discard" means for it (e.g. resetting a `d` doc to `originalD`).
 */
export const requestGuardedUpdate = <S>(
  isDirty: boolean,
  update: SetStateAction<S>
): { apply: SetStateAction<S> | null; hold: SetStateAction<S> | null } =>
  isDirty ? { apply: null, hold: update } : { apply: update, hold: null };
